export const idx_data_pitch_16p = [];

let order = 0;

idx_data_pitch_16p.push({
  fraction: '---',
  decimal: 0,
  order_idx: -1,
});

for (let i = 0; i < 2; i++) {
  let pref = i > 0 ? '' + i + ' ' : '';

  idx_data_pitch_16p.push({
    fraction: i === 0 ? '0' : pref.trim(),
    decimal: i,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '+',
    decimal: i + 1 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/16',
    decimal: i + 1 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/16+',
    decimal: i + 3 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/8',
    decimal: i + 1 / 8,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/8+',
    decimal: i + 5 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '3/16',
    decimal: i + 3 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '3/16+',
    decimal: i + 7 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/4',
    decimal: i + 1 / 4,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/4+',
    decimal: i + 9 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '5/16',
    decimal: i + 5 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '5/16+',
    decimal: i + 11 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '3/8',
    decimal: i + 3 / 8,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '3/8+',
    decimal: i + 13 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '7/16',
    decimal: i + 7 / 16,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '7/16+',
    decimal: i + 15 / 32,
    order_idx: order,
  });
  order++;

  idx_data_pitch_16p.push({
    fraction: pref + '1/2',
    decimal: i + 1 / 2,
    order_idx: order,
  });
  order++;

  if (i < 1) {
    idx_data_pitch_16p.push({
      fraction: pref + '1/2+',
      decimal: i + 17 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '9/16',
      decimal: i + 9 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '9/16+',
      decimal: i + 19 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '5/8',
      decimal: i + 5 / 8,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '5/8+',
      decimal: i + 21 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '11/16',
      decimal: i + 11 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '11/16+',
      decimal: i + 23 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '3/4',
      decimal: i + 3 / 4,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '3/4+',
      decimal: i + 25 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '13/16',
      decimal: i + 13 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '13/16+',
      decimal: i + 27 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '7/8',
      decimal: i + 7 / 8,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '7/8+',
      decimal: i + 29 / 32,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '15/16',
      decimal: i + 15 / 16,
      order_idx: order,
    });
    order++;

    idx_data_pitch_16p.push({
      fraction: pref + '15/16+',
      decimal: i + 31 / 32,
      order_idx: order,
    });
    order++;
  }
}
